import React from 'react';
// component
import Header from '../components/public/Header';
// React Bootstrap
import { Container, Accordion, Card, Button, } from 'react-bootstrap';
// react redux
import { connect } from 'react-redux';

function Schedule({ lang }) {
    return (
        <>
            <Header />
            <Container>
                <div>
                    <h2 className='text-left text-secondary chinese m-2'>
                        Schedule
                    </h2>
                </div>
                <div>
                    <Accordion className='text-left'>
                        <Card className='d-block'>
                            <Card.Header>
                                <Accordion.Toggle as={Button} variant="link" eventKey="4">
                                    <p className='text-left mb-0'>
                                        大手印初階閉關~法味 倉薩貢噶仁波切指導 (台中場12/5-12/6) <br />
                                        活動日期：2020-12-05
                                       </p>
                                </Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey="4">
                                <Card.Body>
                                    <p>
                                        ◆大手印初階閉關~法味 <br /> <br />


                                        大成就者薩惹哈云:『無生的究竟勝義締只存在上師的唇間!了悟上師之語的究竟本性,心即無死,身亦不老。』<br />

                                        伏藏師蔣央洛竹仁欽尊者云:『本初法性自面,平凡原始意識,無改自然當中,非修所得勝道。』<br />

                                        成就大手印悉地即生圓二次第結合智慧與方便一體的境界，當空性與慈悲雙運即是大手印合一之道。
                                        <br />
                                        在大手印初階課程中,仁波切將以密集兩日的閉關模式為各位解說八融噶舉傳承的殊勝大手印。八融噶舉傳承在藏區的住山閉關行者仍然持續實踐著祖師們的教言，目前共有２０幾個閉關中心及百多位閉關瑜伽行者，不間斷的延續著正法並讓佛法永存。
<br />
                                        <br />
                                        ◆倉薩貢噶仁波切 介紹
<br />

                                        倉薩貢噶仁波切，於西元1979年出生於東藏地區，仁波切的祖父是囊謙地區著名伏藏師，父親是一位金剛上師同時也是當地著名的藏醫。 仁波切自幼就信仰三寶，先後被八融噶舉法王蔣央洛竹仁欽與昂稱祖古認證為丹增多傑的第五位轉世，是藏傳佛教噶舉派中四大派之八融噶舉教派的法脈傳承者，從八歲起仁波切師從 伏藏師第四世的蔣央洛竹仁欽法王，尊者乃八融噶舉傳承珍寶且身兼四派之傳承。
<br />
                                        仁波切在佛學院進行為期九年的佛法聞思修後於二十三歲時圓滿完成了三年三個月的閉關並接著擔任閉關中心指導上師。此後，仁波切為了饒益更多有情眾生，於西元2002年起開始在世界各地弘法，仁波在新加坡和台灣分別成立八融噶舉律美多傑佛法中心和八融噶舉菩提佛學會，八融般若文化教育協會。2013年仁波切於青海曩謙縣創辦孤貧職業學校；又於2018年創立民辦幼兒園，致力於偏鄉兒童的啟蒙教育至今。
<br />
                                        <br />
                                        ➡️報名資訊如下➡️
<br />
                                        <br />
                                        ◇課程費用: 僧眾免費,
<br />
                                        居士 1500元(含供養參與本次課程的僧眾)。
<br />
                                        ◇日期:2020年12月05日~12月06日
<br />
                                        ◇時間:早上10:00- 12:00，下午2:00-4:00。
<br />
                                        ◇地點: 台中市西屯區福科路362巷1號2樓。
<br />
                                        (開車及摩托車的佛友可直接將車停放在四樓，出入本棟大樓請走停車場車道上二樓~敬請注意安全小心後方來車)
<br />
                                        ◇主辦單位: 八融般若文化教育協會
<br />
                                        ◇聯絡電話：0912-852738
<br />
                                        ◇注意事項：提醒您攜帶口罩、筆記本。
<br />
                                        ◇護持專戶ATM轉帳：
<br />
                                        台新銀行(812)
<br />
                                        帳號:20781000298825
                                          </p>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                        <Card className='d-block'>
                            <Card.Header>
                                <Accordion.Toggle as={Button} variant="link" eventKey="3">
                                    <p className='text-left mb-0'>
                                        大手印初階閉關~法味 倉薩貢噶仁波切指導 (台北場12/19-12/20) <br />
                                        活動日期：2020-12-19
                                       </p>
                                </Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey="3">
                                <Card.Body>
                                    <p>
                                        ◆大手印初階閉關~法味
<br />
                                        <br />
大成就者薩惹哈云:『無生的究竟勝義締只存在上師的唇間!了悟上師之語的究竟本性,心即無死,身亦不老。』
<br />
伏藏師蔣央洛竹仁欽尊者云:『本初法性自面,平凡原始意識,無改自然當中,非修所得勝道。』
<br />
成就大手印悉地即生圓二次第結合智慧與方便一體的境界，當空性與慈悲雙運即是大手印合一之道。
<br />
在大手印初階課程中,仁波切將以密集兩日的閉關模式為各位解說八融噶舉傳承的殊勝大手印。八融噶舉傳承在藏區的住山閉關行者仍然持續實踐著祖師們的教言，目前共有２０幾個閉關中心及百多位閉關瑜伽行者，不間斷的延續著正法並讓佛法永存。
<br />
                                        <br />
◆倉薩貢噶仁波切 介紹
<br />
                                        <br />
倉薩貢噶仁波切，於西元1979年出生於東藏地區，仁波切的祖父是囊謙地區著名伏藏師，父親是一位金剛上師同時也是當地著名的藏醫。 仁波切自幼就信仰三寶，先後被八融噶舉法王蔣央洛竹仁欽與昂稱祖古認證為丹增多傑的第五位轉世，是藏傳佛教噶舉派中四大派之八融噶舉教派的法脈傳承者，從八歲起仁波切師從 伏藏師第四世的蔣央洛竹仁欽法王，尊者乃八融噶舉傳承珍寶且身兼四派之傳承。
<br />
仁波切在佛學院進行為期九年的佛法聞思修後於二十三歲時圓滿完成了三年三個月的閉關並接著擔任閉關中心指導上師。此後，仁波切為了饒益更多有情眾生，於西元2002年起開始在世界各地弘法，仁波在新加坡和台灣分別成立八融噶舉律美多傑佛法中心和八融噶舉菩提佛學會，八融般若文化教育協會。2013年仁波切於青海曩謙縣創辦孤貧職業學校；又於2018年創立民辦幼兒園，致力於偏鄉兒童的啟蒙教育至今。
<br />
                                        <br />
➡️報名資訊如下➡️
<br />
                                        <br />
◇課程費用: 僧眾免費,
<br />
居士 1500元(含供養參與本次課程的僧眾)。
<br />
◇日期:2020年12月19日~12月20日
<br />
◇時間:早上10:00- 12:00，下午2:00-4:00。
<br />
◇地點: 新北市瑞芳區明燈路三段40號B1 ( 瑞芳火車站旁)
<br />
◇主辦單位: 八融般若文化教育協會
<br />
◇聯絡電話：0912-852738
<br />
◇注意事項：提醒您攜帶口罩、筆記本。
<br />
◇護持專戶ATM轉帳：
<br />
台新銀行(812)
<br />
帳號:20781000298825
                                          </p>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                        <Card className='d-block disabled'>
                            <Card.Header>
                                <Accordion.Toggle as={Button} variant="link" eventKey="0">
                                    <p className='text-left mb-0'>
                                        夢瑜伽初階~覺夢 <br />
                                     活動日期：2020-10-17
                                       </p>
                                </Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey="0">
                                <Card.Body>
                                    <p>
                                        ◆夢瑜伽初階～覺夢<br /><br />

睡夢中陰諸幻象，幻象乃業所習成，騎乘愚痴之馬駒，寬坦悠遊光明原，欸瑪豈非甚妙耶？  法尊 索南桑波 造眾生於有限之身壽當中，近三分之一的時間於睡眠之中度過，如能善加運用睡夢中陰，則不但可幫助行者直指自心本性，更可經由轉化睡夢中陰之情境，進而連結甚至改變生處中陰，行持並利益有情眾生事業。 閉關瑜伽行者更將夢瑜珈視為取成就的重要徵兆。
<br /><br />
◆【倉薩貢噶仁波切】介紹：
<br /><br />
倉薩貢噶仁波切，於西元1979年出生於東藏地區，仁波切自幼就信仰三寶，先後被巴融噶舉法王蔣央洛竹仁欽與昂稱祖古認證為丹增多傑的第五位轉世，仁波切是藏傳佛教噶舉派中四大派之巴融噶舉教派的法脈傳承者，從八歲起仁波切師從多位尊貴的上師如第四世的蔣央洛竹仁欽尊者不僅為巴融噶舉的法王與傳承珍寶，而且身兼四派之傳承。
<br />
仁波切在佛學院進行為期九年的佛法聞思修。於二十三歲時圓滿完成了三年三個月的閉關並接著並擔任閉關中心指導上師。此後，仁波切為了饒益更多有情眾生，於西元2002年起開始在世界各地弘法，仁波在新加坡和台灣分別成立八融噶舉律美多傑佛法中心和八融噶舉菩提佛學會，八融般若文化教育協會。2013年仁波切於青海曩謙縣創辦孤貧職業學校；又於2018年創立民辦幼兒園，致力於偏鄉兒童的啟蒙教育。
<br /><br />
➡️報名資訊如下➡️
<br /><br />
◇費用: 3000元（共兩天四堂課)，
<br />
出家師父2000元。
<br />
◇日期:  2020年10月17日~10月18日
<br />
◇時間: 早上10:00 - 12:00，下午2:00-4:00。
<br />
◇地點: 台中市西屯區福科路362巷1號2樓。
<br />
(開車及摩托車的佛友可直接將車停放在四樓，出入本棟大樓請走車道靠右人行步道，並注意安全)
<br />
◇聯絡電話：0912852738
<br />
◇注意事項：提醒您攜帶瑜伽墊及口罩、筆記本。
<br />
◇護持專戶ATM轉帳：
<br />
台新銀行(812)
<br />
帳號: 20781000298825
</p>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                        <Card className='d-block'>
                            <Card.Header>
                                <Accordion.Toggle as={Button} variant="link" eventKey="1">
                                    <p className='text-left mb-0'>
                                        2020西藏青美幻輪瑜伽(台北場) <br />
                                        活動日期：2020-10-27
                                       </p>
                                </Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey="1">
                                <Card.Body>
                                    <p>
                                        ◆《西藏青美幻輪瑜伽》簡介：<br /><br />


西藏青美幻輪瑜伽是一系列簡潔的肢體動作結合有規律的呼吸及西藏醫學理論為基礎而發展。主要是發展於西藏山區閉關的僧侶，為了輔助一些傳統學習的系統，以使他們的身體保持最佳能量狀態，增強其免疫系統並調整其康復能力。
此外，他們的主要目標始終是發展心性上的證悟和對現實本質的高度認識。
對於非閉關的行者，現代人練習西藏青美幻輪，能快速作用於身體，思想和精神健康的層面，產生改變及影響生命的品質。
通過以這種特定方式與身體及意念層次的合作，我們可以深入對治各類疾病，使精神思路清晰，提高及平衡情緒，讓修行者產生自體抵抗力。
換句話說，通過西藏青美幻輪瑜伽，您會發現心的力量，穩定的情緒和愉悅幸福的感受及生命創造的能量。
表面上這是西藏傳佛教的學習系統，許多人沒有意識到其實在藏傳佛教內部有動禪的傳統。人們認為佛教徒的禪修是靜態的並且是一定要坐在拜墊上。由於通過幻輪瑜伽的修習，我們得以讓動靜之間緊密聯繫，因此可以通過身體在精神層面上起作用。
<br />
佛陀在時輪金剛密續中教給我們有關在我們整個身體中的數千種通道。這些通道的健康狀況決定著我們的整體健康狀況，因為它們可以輸送人體的液體（如血液和淋巴液）以及氧氣和人體更細微的重要風或能量。除了增加我們對疾病的易感性之外，通道中的阻塞還直接影響我們的思維穩定性，表現為情緒不安和注意力不集中。因此，通過學習西藏青美幻輪瑜伽而專注於禪修身體內部通道的開放性和靈活性，我們在身體，心理和精神能量的水平上提高自己。
<br /><br />

◆【倉薩貢噶仁波切】介紹：
<br /><br />
倉薩貢噶仁波切，於西元1979年出生於東藏地區，仁波切自幼就信仰三寶，先後被巴融噶舉法王蔣央洛竹仁欽與昂稱祖古認證為丹增多傑的第五位轉世，仁波切是藏傳佛教噶舉派中四大派之巴融噶舉教派的法脈傳承者，八歲起仁波切師從多位尊貴的上師如 第四世的蔣央洛竹仁欽尊者為巴融噶舉的法王與傳承珍寶，而且身兼四派之傳承。
倉薩貢噶仁波切在佛學院進行為期九年的聞思修法並於二十三歲時圓滿完成了三年三個月的閉關。完滿出關後接著擔任閉關中心指導上師。仁波切為了饒益更多有情眾生，於西元2002年起開始在世界各地弘法，仁波在新加坡和台灣分別成立巴融噶舉律美多傑佛法中心和八融噶舉菩提佛學會，八融般若文化教育協會。2013年仁波切於青海曩謙縣創辦孤貧職業學校；又於2018年創立民辦幼兒園，致力於偏鄉兒童的啟蒙教育。
仁波切亦對西藏文化的傳承不遺餘力，在教學之餘更致力於西藏書法文化在海內外傳遞家族的書法傳承。

 <br /><br />

☆報名資訊如下：
<br />
◇費用: 5000元（每週一次共四堂課)，出家師父3000元。
<br />
◇日期:
<br />
2020年10月27日晚上6:30-8:30
<br />
2020年11月03日 晚上6:30-8:30
<br />
2020年11月10日晚上6:30-8:30
<br />
2020年11月17日晚上6:30-8:30
<br />
◇地點:
<br />
台北市信義區松山路650巷21弄18-1號(象山農場王母區)

<br />
◇聯絡電話:0912852738

<br />
◇注意事項：提醒您攜帶瑜伽墊，筆記本，口罩。
<br />
◇護持專戶ATM轉帳：
<br />
台新銀行(812)
<br />
帳號20781000298825
<br />
報名後請回傳轉帳帳號後五碼
                                    </p>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                </div>
            </Container>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        lang: state.lang.lang,
    };
};

export default connect(mapStateToProps)(Schedule);
